import {
  LIBRARY_PROMO_ASK_CONFIRMATION_UPDATE,
  LIBRARY_PROMO_CANCEL_CONFIRM_REACTIVATE,
  LIBRARY_PROMO_CANCEL_DEACTIVATE,
  LIBRARY_PROMO_CANCEL_DELETE,
  LIBRARY_PROMO_CANCEL_REACTIVATE,
  LIBRARY_PROMO_CLOSE_RIGHT_COLUMN,
  LIBRARY_PROMO_CONFIRM_REACTIVATE_PROMO,
  LIBRARY_PROMO_DEACTIVATE_PROMO,
  LIBRARY_PROMO_DELETE_PROMO,
  LIBRARY_PROMO_GET_LIST_PROMO_REQUEST,
  LIBRARY_PROMO_HIDE_ASSIGN_OUTLET_MODAL,
  LIBRARY_PROMO_HIDE_CONFIRM_REACTIVATE_MODAL,
  LIBRARY_PROMO_HIDE_DEACTIVATE_MODAL,
  LIBRARY_PROMO_HIDE_DELETE_MODAL,
  LIBRARY_PROMO_HIDE_REACTIVATE_MODAL,
  LIBRARY_PROMO_HIDE_UPDATE_CONFIRM_MODAL,
  LIBRARY_PROMO_ON_CANCEL_UPDATE_CONFIRMATION,
  LIBRARY_PROMO_ON_CHANGE_ITEM_REWARD_BUY_X_GET_Y,
  LIBRARY_PROMO_ON_CHANGE_KEYWORD,
  LIBRARY_PROMO_ON_CHANGE_PR_BUY_X_GET_Y,
  LIBRARY_PROMO_ON_CHANGE_PROMO_TYPES,
  LIBRARY_PROMO_ON_CHANGE_STATUS,
  LIBRARY_PROMO_ON_CHANGE_SWITCH_FIELD_DISCOUNT,
  LIBRARY_PROMO_ON_CLICK_ASSIGN_OUTLET,
  LIBRARY_PROMO_ON_CLICK_ASSIGN_PROMO_ASSIGN_OUTLET_MODAL,
  LIBRARY_PROMO_ON_CLICK_CANCEL_ASSIGN_OUTLET_MODAL,
  LIBRARY_PROMO_ON_CLICK_CANCEL_PROMO,
  LIBRARY_PROMO_ON_CLICK_CREATE_PROMO,
  LIBRARY_PROMO_ON_CLICK_DEACTIVATE,
  LIBRARY_PROMO_ON_CLICK_DELETE,
  LIBRARY_PROMO_ON_CLICK_REACTIVATE,
  LIBRARY_PROMO_ON_CLICK_ROW,
  LIBRARY_PROMO_ON_CONFIRM_UPDATE,
  LIBRARY_PROMO_ON_CREATE_PROMO_BUY_X_GET_Y,
  LIBRARY_PROMO_ON_REACH_BUTTOM,
  LIBRARY_PROMO_ON_SUBMIT_EACH_PROMO_FORM,
  LIBRARY_PROMO_ON_SUBMIT_FIRST_FORM,
  LIBRARY_PROMO_ON_SUBMIT_SECOND_FORM,
  LIBRARY_PROMO_ON_SUBMIT_THIRD_FORM,
  LIBRARY_PROMO_OPEN_RIGHT_COLUMN,
  LIBRARY_PROMO_PAGE_REQUEST,
  LIBRARY_PROMO_REACTIVATE_PROMO,
  LIBRARY_PROMO_SEARCH_OUTLET,
  LIBRARY_PROMO_SELECT_ALL_OUTLETS,
  LIBRARY_PROMO_SET_ACCORDION_ACTIVE_KEY,
  LIBRARY_PROMO_SET_ACTION_UPDATE_NAME,
  LIBRARY_PROMO_SET_CURRENT_PAGE,
  LIBRARY_PROMO_SET_DEACTIVATED_PROMO,
  LIBRARY_PROMO_SET_DELETED_PROMO,
  LIBRARY_PROMO_SET_DETAIL_PROMO,
  LIBRARY_PROMO_SET_INTERSECT_CATEGORIES,
  LIBRARY_PROMO_SET_INTERSECT_ITEMS,
  LIBRARY_PROMO_SET_INTERSECT_VARIANTS,
  LIBRARY_PROMO_SET_IS_SUBMITTED_EACH_PROMO_FORM,
  LIBRARY_PROMO_SET_IS_SUBMITTING_FORM,
  LIBRARY_PROMO_SET_LIST_PROMO,
  LIBRARY_PROMO_SET_NEXT_UPDATE_ACTION,
  LIBRARY_PROMO_SET_OUTLETS,
  LIBRARY_PROMO_SET_PREV_ASSIGNED_OUTLETS,
  LIBRARY_PROMO_SET_PROMO_TYPES,
  LIBRARY_PROMO_SET_REACTIVATED_PROMO,
  LIBRARY_PROMO_SET_SELECTED_OUTLETS,
  LIBRARY_PROMO_SET_TOTAL_PAGE,
  LIBRARY_PROMO_SHOW_ASSIGN_OUTLET_MODAL,
  LIBRARY_PROMO_SHOW_CONFIRM_REACTIVATE_MODAL,
  LIBRARY_PROMO_SHOW_DEACTIVATE_MODAL,
  LIBRARY_PROMO_SHOW_DELETE_MODAL,
  LIBRARY_PROMO_SHOW_REACTIVATE_MODAL,
  LIBRARY_PROMO_SHOW_UPDATE_CONFIRM_MODAL,
  LIBRARY_PROMO_UNSELECT_ALL_OUTLETS,
  LIBRARY_PROMO_UPDATE_PROMO,
  LIBRARY_PROMO_ON_CLICK_ASSIGN_ITEMS,
  LIBRARY_PROMO_SHOW_ASSIGN_ITEMS_MODAL,
  LIBRARY_PROMO_SET_CATEGORIES,
  LIBRARY_PROMO_HIDE_ASSIGN_ITEMS_MODAL,
  LIBRARY_PROMO_SET_ITEM_DETAILS,
  LIBRARY_PROMO_ASSIGN_ITEMS_ON_CLICK_CANCEL,
  LIBRARY_PROMO_ASSIGN_ITEMS_ON_CHANGE_SEARCH,
  LIBRARY_PROMO_ASSIGN_ITEMS_ON_CHANGE_CATEGORY,
  LIBRARY_PROMO_ASSIGN_ITEMS_ON_CLICK_ASSIGN_ITEMS,
  LIBRARY_PROMO_ASSIGN_ITEMS_SET_ASSIGNED_PROMOS,
  LIBRARY_PROMO_ON_CREATE_GOSTORE_PRICE_CUTS_PROMO,
  LIBRARY_PROMO_ON_CREATE_ADVANCE_PROMO,
  LIBRARY_PROMO_ON_UPDATE_ADVANCE_PROMO,
  LIBRARY_PROMO_SET_NON_DELETED_PROMOS,
  LIBRARY_PROMO_SELECT_APPLY_DISCOUNT_TO_ALL_ITEMS,
  LIBRARY_PROMO_SET_ERRORS_PRICE_CUTS_PROMO,
  LIBRARY_PROMO_SHOW_ERROR_MODAL_PRICE_CUTS_PROMO,
  LIBRARY_PROMO_HIDE_ERROR_MODAL_PRICE_CUTS_PROMO,
  LIBRARY_PROMO_REACTIVATE_GOSTORE_PRICE_CUTS_PROMO,
  LIBRARY_PROMO_ON_UPDATE_GOSTORE_PRICE_CUTS_PROMO,
  LIBRARY_PROMO_ON_CLICK_ROW_GOSTORE_PRICE_CUTS_PROMO,
  LIBRARY_PROMO_ASSIGN_ITEMS_SET_CURRENT_PAGE,
  LIBRARY_PROMO_ASSIGN_ITEMS_SET_TOTAL_PAGE,
  LIBRARY_PROMO_ASSIGN_ITEMS_ON_REACH_BUTTOM,
  LIBRARY_PROMO_SET_SELECTED_GOSTORE_ITEMS,
  LIBRARY_PROMO_SHOW_ASSIGN_SALES_TYPE_MODAL,
  LIBRARY_PROMO_HIDE_ASSIGN_SALES_TYPE_MODAL,
  LIBRARY_PROMO_SET_SALES_TYPES,
  LIBRARY_PROMO_ON_CLICK_ASSIGN_PROMO_ASSIGN_SALES_TYPE_MODAL,
  LIBRARY_PROMO_ON_CHANGE_SALES_TYPE_NAMESPACE,
  LIBRARY_PROMO_ON_CLICK_ASSIGN_SALES_TYPE,
  LIBRARY_PROMO_ON_CLICK_CANCEL_ASSIGN_SALES_TYPE_MODAL,
  LIBRARY_PROMO_UNSELECT_ALL_SALES_TYPES,
  LIBRARY_PROMO_SEARCH_SALES_TYPE,
  LIBRARY_PROMO_SELECT_ALL_SALES_TYPES,
  LIBRARY_PROMO_SET_SELECTED_SALES_TYPES,
  LIBRARY_PROMO_SET_SALES_TYPE_NAMESPACE,
  LIBRARY_PROMO_ON_CHANGE_ALREADY_ASSIGNED_OUTLET,
  LIBRARY_PROMO_SET_ALREADY_ASSIGNED_OUTLET,
  LIBRARY_PROMO_SHOW_ASSIGN_OUTLET_WARN_MODAL,
  LIBRARY_PROMO_HIDE_ASSIGN_OUTLET_WARN_MODAL,
  LIBRARY_PROMO_SHOW_ASSIGN_OUTLET_WARN,
  LIBRARY_PROMO_HIDE_ASSIGN_OUTLET_WARN,
  LIBRARY_PROMO_SHOW_ASSIGN_SALES_TYPE_WARN,
  LIBRARY_PROMO_HIDE_ASSIGN_SALES_TYPE_WARN,
  LIBRARY_PROMO_ON_CONFIRM_ASSIGN_OUTLET_WARN_MODAL,
  LIBRARY_PROMO_SET_PREVIOUS_SALES_TYPE,
} from './constants';

export function promoPageRequest(flagPromoV2) {
  return {
    type: LIBRARY_PROMO_PAGE_REQUEST,
    payload: { flagPromoV2 },
  };
}

export function onClickCreatePromo(outlets, salesTypes?) {
  return {
    type: LIBRARY_PROMO_ON_CLICK_CREATE_PROMO,
    payload: { outlets, salesTypes },
  };
}

export function openRightColumn() {
  return {
    type: LIBRARY_PROMO_OPEN_RIGHT_COLUMN,
    payload: {},
  };
}

export function closeRightColumn() {
  return {
    type: LIBRARY_PROMO_CLOSE_RIGHT_COLUMN,
    payload: {},
  };
}

export function onClickCancel() {
  return {
    type: LIBRARY_PROMO_ON_CLICK_CANCEL_PROMO,
    payload: {},
  };
}

export function setAccordionActiveKey(activeKey) {
  return {
    type: LIBRARY_PROMO_SET_ACCORDION_ACTIVE_KEY,
    payload: { activeKey },
  };
}

export function setPromoTypes(promoTypes) {
  return {
    type: LIBRARY_PROMO_SET_PROMO_TYPES,
    payload: { promoTypes },
  };
}

export function showPromoAssignOutletModal() {
  return {
    type: LIBRARY_PROMO_SHOW_ASSIGN_OUTLET_MODAL,
    payload: {},
  };
}

export function hidePromoAssignOutletModal() {
  return {
    type: LIBRARY_PROMO_HIDE_ASSIGN_OUTLET_MODAL,
    payload: {},
  };
}

export function setPreviousSalesTypeNames(previousSalesTypeNames) {
  return {
    type: LIBRARY_PROMO_SET_PREVIOUS_SALES_TYPE,
    payload: { previousSalesTypeNames },
  };
}

export function setOutlets(outlets) {
  return {
    type: LIBRARY_PROMO_SET_OUTLETS,
    payload: { outlets },
  };
}

export function onClickAssignOutletButton(
  previousSelectedOutlets,
  selectedOutletsForm
) {
  return {
    type: LIBRARY_PROMO_ON_CLICK_ASSIGN_OUTLET,
    payload: { previousSelectedOutlets, selectedOutletsForm },
  };
}

export function onClickCancelModal(previousSelectedOutlets) {
  return {
    type: LIBRARY_PROMO_ON_CLICK_CANCEL_ASSIGN_OUTLET_MODAL,
    payload: { previousSelectedOutlets },
  };
}

export function onClickAssignPromoModal(
  selectedOutletIds,
  assignedOutlets,
  alreadyAssignedOutlet,
  isGoStorePromoSelected
) {
  return {
    type: LIBRARY_PROMO_ON_CLICK_ASSIGN_PROMO_ASSIGN_OUTLET_MODAL,
    payload: {
      selectedOutletIds,
      assignedOutlets,
      alreadyAssignedOutlet,
      isGoStorePromoSelected,
    },
  };
}

export function searchOutlet(outlets, searchKeyword) {
  return {
    type: LIBRARY_PROMO_SEARCH_OUTLET,
    payload: { outlets, searchKeyword },
  };
}

export function selectAllOutlets(allOutletsForm) {
  return {
    type: LIBRARY_PROMO_SELECT_ALL_OUTLETS,
    payload: { allOutletsForm },
  };
}

export function setSelectedOutlets(selectedOutlets) {
  return {
    type: LIBRARY_PROMO_SET_SELECTED_OUTLETS,
    payload: { selectedOutlets },
  };
}

export function unselectAllOutlets(allOutletsForm) {
  return {
    type: LIBRARY_PROMO_UNSELECT_ALL_OUTLETS,
    payload: { allOutletsForm },
  };
}

export function onSubmitEachPromoForm(
  oldPromoForm,
  promoFormName,
  isSubmitted
) {
  return {
    type: LIBRARY_PROMO_ON_SUBMIT_EACH_PROMO_FORM,
    payload: { oldPromoForm, promoFormName, isSubmitted },
  };
}

export function setIsSubmittedPromoForm(newPromoForm) {
  return {
    type: LIBRARY_PROMO_SET_IS_SUBMITTED_EACH_PROMO_FORM,
    payload: { newPromoForm },
  };
}

export function onSubmitFirstForm(
  formValues,
  outlets,
  salesTypes,
  formName,
  oldPromoForm,
  detailPromo,
  isOutletDifferent,
  promoType?,
  purchaseRequirementForm?
) {
  return {
    type: LIBRARY_PROMO_ON_SUBMIT_FIRST_FORM,
    payload: {
      formValues,
      outlets,
      salesTypes,
      formName,
      oldPromoForm,
      detailPromo,
      isOutletDifferent,
      promoType,
      purchaseRequirementForm,
    },
  };
}

export function setIntersectItems(items) {
  return {
    type: LIBRARY_PROMO_SET_INTERSECT_ITEMS,
    payload: { items },
  };
}

export function setIntersectCategories(categories) {
  return {
    type: LIBRARY_PROMO_SET_INTERSECT_CATEGORIES,
    payload: { categories },
  };
}

export function setIsSubmittingForm(isSubmit) {
  return {
    type: LIBRARY_PROMO_SET_IS_SUBMITTING_FORM,
    payload: { isSubmit },
  };
}

export function setIntersectItemVariants(variants) {
  return {
    type: LIBRARY_PROMO_SET_INTERSECT_VARIANTS,
    payload: { variants },
  };
}

/**
 * This function will handle change event if users change item
 * in Buy X Get Y Promo type
 */
export function onChangeItemPRBuyXGetY(
  formName,
  formValue,
  oldVariants,
  selectedOutlets
) {
  return {
    type: LIBRARY_PROMO_ON_CHANGE_PR_BUY_X_GET_Y,
    payload: { formName, formValue, oldVariants, selectedOutlets },
  };
}

export function onSubmitSecondForm(
  formValues,
  formName,
  oldPromoForm,
  detailPromo,
  isOutletDifferent,
  promoType?
) {
  return {
    type: LIBRARY_PROMO_ON_SUBMIT_SECOND_FORM,
    payload: {
      formValues,
      formName,
      oldPromoForm,
      detailPromo,
      isOutletDifferent,
      promoType,
    },
  };
}

export function onChangeItemRewardBuyXGetY(
  fieldName,
  formValue,
  oldVariants,
  selectedOutlets
) {
  return {
    type: LIBRARY_PROMO_ON_CHANGE_ITEM_REWARD_BUY_X_GET_Y,
    payload: { fieldName, formValue, oldVariants, selectedOutlets },
  };
}

export function onChangeSwitchField() {
  return {
    type: LIBRARY_PROMO_ON_CHANGE_SWITCH_FIELD_DISCOUNT,
    payload: {},
  };
}

export function onSubmitThirdForm(
  formValues,
  formName,
  oldPromoForm,
  detailPromo
) {
  return {
    type: LIBRARY_PROMO_ON_SUBMIT_THIRD_FORM,
    payload: { formValues, formName, oldPromoForm, detailPromo },
  };
}

/**
 * This function will handle create event for Promo Type Buy X Get Y
 */
export function onCreatePromoBuyXGetY(
  typeAndConfig,
  purchaseRequirement,
  reward,
  isSubmitPromoForm,
  hashedOutlets,
  flagPromoV2
) {
  return {
    type: LIBRARY_PROMO_ON_CREATE_PROMO_BUY_X_GET_Y,
    payload: {
      typeAndConfig,
      purchaseRequirement,
      reward,
      isSubmitPromoForm,
      hashedOutlets,
      flagPromoV2,
    },
  };
}

export function getListPromo(params, hashedOutlet) {
  return {
    type: LIBRARY_PROMO_GET_LIST_PROMO_REQUEST,
    payload: { params, hashedOutlet },
  };
}

export function setListPromo(promos) {
  return {
    type: LIBRARY_PROMO_SET_LIST_PROMO,
    payload: { promos },
  };
}

export function setCurrentPage(currentPage) {
  return {
    type: LIBRARY_PROMO_SET_CURRENT_PAGE,
    payload: { currentPage },
  };
}

export function setTotalPage(totalPage) {
  return {
    type: LIBRARY_PROMO_SET_TOTAL_PAGE,
    payload: { totalPage },
  };
}

export function onClickRow(promo, promoTypes, outlets, flagPromoV2) {
  return {
    type: LIBRARY_PROMO_ON_CLICK_ROW,
    payload: { promo, promoTypes, outlets, flagPromoV2 },
  };
}

export function setDetailPromo(detailPromo) {
  return {
    type: LIBRARY_PROMO_SET_DETAIL_PROMO,
    payload: { detailPromo },
  };
}

export function onClickDelete(promo) {
  return {
    type: LIBRARY_PROMO_ON_CLICK_DELETE,
    payload: { promo },
  };
}

export function showDeleteModal() {
  return {
    type: LIBRARY_PROMO_SHOW_DELETE_MODAL,
    payload: {},
  };
}

export function hideDeleteModal() {
  return {
    type: LIBRARY_PROMO_HIDE_DELETE_MODAL,
    payload: {},
  };
}

export function cancelDelete() {
  return {
    type: LIBRARY_PROMO_CANCEL_DELETE,
    payload: {},
  };
}

export function deletePromo(promoId, previousPromos, flagPromoV2) {
  return {
    type: LIBRARY_PROMO_DELETE_PROMO,
    payload: { promoId, previousPromos, flagPromoV2 },
  };
}

export function setDeletedPromo(deletedPromo) {
  return {
    type: LIBRARY_PROMO_SET_DELETED_PROMO,
    payload: { deletedPromo },
  };
}

export function onClickDeactivate(promo) {
  return {
    type: LIBRARY_PROMO_ON_CLICK_DEACTIVATE,
    payload: { promo },
  };
}

export function showDeactivateModal() {
  return {
    type: LIBRARY_PROMO_SHOW_DEACTIVATE_MODAL,
    payload: {},
  };
}

export function hideDeactivateModal() {
  return {
    type: LIBRARY_PROMO_HIDE_DEACTIVATE_MODAL,
    payload: {},
  };
}

export function cancelDeactivate() {
  return {
    type: LIBRARY_PROMO_CANCEL_DEACTIVATE,
    payload: {},
  };
}

export function deactivatePromo(promo, hashedOutlets, flagPromoV2) {
  return {
    type: LIBRARY_PROMO_DEACTIVATE_PROMO,
    payload: { promo, hashedOutlets, flagPromoV2 },
  };
}

export function setDeactivatedPromo(deactivatedPromo) {
  return {
    type: LIBRARY_PROMO_SET_DEACTIVATED_PROMO,
    payload: { deactivatedPromo },
  };
}

export function onClickReactivate(promo) {
  return {
    type: LIBRARY_PROMO_ON_CLICK_REACTIVATE,
    payload: { promo },
  };
}

export function showReactivateModal() {
  return {
    type: LIBRARY_PROMO_SHOW_REACTIVATE_MODAL,
    payload: {},
  };
}

export function hideReactivateModal() {
  return {
    type: LIBRARY_PROMO_HIDE_REACTIVATE_MODAL,
    payload: {},
  };
}

export function cancelReactivate() {
  return {
    type: LIBRARY_PROMO_CANCEL_REACTIVATE,
    payload: {},
  };
}

export function reactivatePromo(promo, data, hashedOutlets, flagPromoV2) {
  return {
    type: LIBRARY_PROMO_REACTIVATE_PROMO,
    payload: { promo, data, hashedOutlets, flagPromoV2 },
  };
}

export function setReactivatedPromo(reactivatedPromo) {
  return {
    type: LIBRARY_PROMO_SET_REACTIVATED_PROMO,
    payload: { reactivatedPromo },
  };
}

export function onUpdatePromo(
  promoId,
  updatedData,
  hashedOutlets,
  isDaySelected,
  isHaveTimePeriod,
  flagPromoV2
) {
  return {
    type: LIBRARY_PROMO_UPDATE_PROMO,
    payload: {
      promoId,
      updatedData,
      hashedOutlets,
      isDaySelected,
      isHaveTimePeriod,
      flagPromoV2,
    },
  };
}

export function showConfirmReactivateModal() {
  return {
    type: LIBRARY_PROMO_SHOW_CONFIRM_REACTIVATE_MODAL,
    payload: {},
  };
}

export function hideConfirmReactivateModal() {
  return {
    type: LIBRARY_PROMO_HIDE_CONFIRM_REACTIVATE_MODAL,
    payload: {},
  };
}

export function cancelConfirmReactivate() {
  return {
    type: LIBRARY_PROMO_CANCEL_CONFIRM_REACTIVATE,
    payload: {},
  };
}

export function confirmReactivatePromo(promo, hashedOutlets, flagPromoV2) {
  return {
    type: LIBRARY_PROMO_CONFIRM_REACTIVATE_PROMO,
    payload: { promo, hashedOutlets, flagPromoV2 },
  };
}

export function setPrevAssignedOutlets(prevAssignedOutlet) {
  return {
    type: LIBRARY_PROMO_SET_PREV_ASSIGNED_OUTLETS,
    payload: { prevAssignedOutlet },
  };
}

export function onChangePromoTypes(
  promoTypeId,
  status,
  keyword,
  hashedOutlets
) {
  return {
    type: LIBRARY_PROMO_ON_CHANGE_PROMO_TYPES,
    payload: { promoTypeId, status, keyword, hashedOutlets },
  };
}

export function onChangeStatus(promoTypeId, status, keyword, hashedOutlets) {
  return {
    type: LIBRARY_PROMO_ON_CHANGE_STATUS,
    payload: { promoTypeId, status, keyword, hashedOutlets },
  };
}

export function onChangeKeyword(promoTypeId, status, keyword, hashedOutlets) {
  return {
    type: LIBRARY_PROMO_ON_CHANGE_KEYWORD,
    payload: { promoTypeId, status, keyword, hashedOutlets },
  };
}

export function onReachBottom(oldPromo, queryParams) {
  return {
    type: LIBRARY_PROMO_ON_REACH_BUTTOM,
    payload: { oldPromo, queryParams },
  };
}

export function askConfirmationUpdate(nextUpdateAction) {
  return {
    type: LIBRARY_PROMO_ASK_CONFIRMATION_UPDATE,
    payload: { nextUpdateAction },
  };
}

export function showUpdateConfirmationModal() {
  return {
    type: LIBRARY_PROMO_SHOW_UPDATE_CONFIRM_MODAL,
    payload: {},
  };
}

export function hideUpdateConfirmationModal() {
  return {
    type: LIBRARY_PROMO_HIDE_UPDATE_CONFIRM_MODAL,
    payload: {},
  };
}

export function confirmUpdatePromo(nextUpdateAction) {
  return {
    type: LIBRARY_PROMO_ON_CONFIRM_UPDATE,
    payload: { nextUpdateAction },
  };
}

export function cancelConfirmUpdate() {
  return {
    type: LIBRARY_PROMO_ON_CANCEL_UPDATE_CONFIRMATION,
    payload: {},
  };
}

export function setNextUpdateAction(nextUpdateAction) {
  return {
    type: LIBRARY_PROMO_SET_NEXT_UPDATE_ACTION,
    payload: { nextUpdateAction },
  };
}

export function setActionUpdateName(actionUpdateName) {
  return {
    type: LIBRARY_PROMO_SET_ACTION_UPDATE_NAME,
    payload: { actionUpdateName },
  };
}

export function onClickAssignItems(
  businessId,
  outletIds,
  promoTypeId,
  detailPromo
) {
  return {
    type: LIBRARY_PROMO_ON_CLICK_ASSIGN_ITEMS,
    payload: {
      businessId,
      outletIds,
      promoTypeId,
      detailPromo,
    },
  };
}

export function setCategories(categories) {
  return {
    type: LIBRARY_PROMO_SET_CATEGORIES,
    payload: { categories },
  };
}

export function showPromoAssignItemsModal() {
  return {
    type: LIBRARY_PROMO_SHOW_ASSIGN_ITEMS_MODAL,
    payload: {},
  };
}

export function hidePromoAssignItemsModal() {
  return {
    type: LIBRARY_PROMO_HIDE_ASSIGN_ITEMS_MODAL,
    payload: {},
  };
}

export function setItemDetails(itemDetails) {
  return {
    type: LIBRARY_PROMO_SET_ITEM_DETAILS,
    payload: { itemDetails },
  };
}

export function onClickCancelAssignItems(selectedItems) {
  return {
    type: LIBRARY_PROMO_ASSIGN_ITEMS_ON_CLICK_CANCEL,
    payload: { selectedItems },
  };
}

export function onChangeSearchAssignItems(
  businessId,
  keyword,
  categoryName,
  outletIds,
  detailPromo,
  promoTypeId
) {
  return {
    type: LIBRARY_PROMO_ASSIGN_ITEMS_ON_CHANGE_SEARCH,
    payload: {
      businessId,
      keyword,
      categoryName,
      outletIds,
      detailPromo,
      promoTypeId,
    },
  };
}

export function onChangeCategoryAssignItems(
  businessId,
  keyword,
  categoryName,
  outletIds,
  detailPromo,
  promoTypeId
) {
  return {
    type: LIBRARY_PROMO_ASSIGN_ITEMS_ON_CHANGE_CATEGORY,
    payload: {
      businessId,
      keyword,
      categoryName,
      outletIds,
      detailPromo,
      promoTypeId,
    },
  };
}

export function onConfirmAssignItems(assignedItems) {
  return {
    type: LIBRARY_PROMO_ASSIGN_ITEMS_ON_CLICK_ASSIGN_ITEMS,
    payload: { assignedItems },
  };
}

export function setAssignedPromos(assignedPromos) {
  return {
    type: LIBRARY_PROMO_ASSIGN_ITEMS_SET_ASSIGNED_PROMOS,
    payload: { assignedPromos },
  };
}

export function onCreateGostorePriceCutsPromo(
  data,
  outletIds,
  isSubmitPromoForm
) {
  return {
    type: LIBRARY_PROMO_ON_CREATE_GOSTORE_PRICE_CUTS_PROMO,
    payload: { data, outletIds, isSubmitPromoForm },
  };
}

export function onCreateAdvancePromo(data, outletIds, isSubmitPromoForm) {
  return {
    type: LIBRARY_PROMO_ON_CREATE_ADVANCE_PROMO,
    payload: { data, outletIds, isSubmitPromoForm },
  };
}

export function onUpdateAdvancePromo(promoId, data, outletIds) {
  return {
    type: LIBRARY_PROMO_ON_UPDATE_ADVANCE_PROMO,
    payload: { promoId, data, outletIds },
  };
}

export function selectApplyDiscountToAllItems(outletIds) {
  return {
    type: LIBRARY_PROMO_SELECT_APPLY_DISCOUNT_TO_ALL_ITEMS,
    payload: { outletIds },
  };
}

export function setNonDeletedPromos(nonDeletedPromos) {
  return {
    type: LIBRARY_PROMO_SET_NON_DELETED_PROMOS,
    payload: { nonDeletedPromos },
  };
}

export function setErrorsPriceCutsPromo(errors) {
  return {
    type: LIBRARY_PROMO_SET_ERRORS_PRICE_CUTS_PROMO,
    payload: { errors },
  };
}

export function showErrorModalPriceCutsPromo() {
  return {
    type: LIBRARY_PROMO_SHOW_ERROR_MODAL_PRICE_CUTS_PROMO,
    payload: {},
  };
}

export function hideErrorModalPriceCutsPromo() {
  return {
    type: LIBRARY_PROMO_HIDE_ERROR_MODAL_PRICE_CUTS_PROMO,
    payload: {},
  };
}

export function reactivateGostorePriceCutsPromo(promo, outletIds) {
  return {
    type: LIBRARY_PROMO_REACTIVATE_GOSTORE_PRICE_CUTS_PROMO,
    payload: { promo, outletIds },
  };
}

export function onUpdateGostorePriceCutsPromo(
  promoId,
  updatedData,
  outletIds,
  isSubmitPromoForm
) {
  return {
    type: LIBRARY_PROMO_ON_UPDATE_GOSTORE_PRICE_CUTS_PROMO,
    payload: { promoId, updatedData, outletIds, isSubmitPromoForm },
  };
}

export function onClickRowPriceCutsPromo(promo, promoTypes, outlets) {
  return {
    type: LIBRARY_PROMO_ON_CLICK_ROW_GOSTORE_PRICE_CUTS_PROMO,
    payload: { promo, promoTypes, outlets },
  };
}

export function setCurrentPageAssignItemsModal(currentPage) {
  return {
    type: LIBRARY_PROMO_ASSIGN_ITEMS_SET_CURRENT_PAGE,
    payload: { currentPage },
  };
}

export function setTotalPageAssignItemsModal(totalPage) {
  return {
    type: LIBRARY_PROMO_ASSIGN_ITEMS_SET_TOTAL_PAGE,
    payload: { totalPage },
  };
}

export function onReachBottomRowAssignItemsModal(
  oldItemDetails,
  queryParams,
  outletIds,
  detailPromo,
  promoTypeId,
  oldAssignedPromos
) {
  return {
    type: LIBRARY_PROMO_ASSIGN_ITEMS_ON_REACH_BUTTOM,
    payload: {
      oldItemDetails,
      queryParams,
      outletIds,
      detailPromo,
      promoTypeId,
      oldAssignedPromos,
    },
  };
}

export function setSelectedGostoreItems(selectedItems) {
  return {
    type: LIBRARY_PROMO_SET_SELECTED_GOSTORE_ITEMS,
    payload: { selectedItems },
  };
}

export function setSalesTypes(salesTypes) {
  return {
    type: LIBRARY_PROMO_SET_SALES_TYPES,
    payload: { salesTypes },
  };
}

export function setSalesTypeNameSpace(salesTypeNameSpace) {
  return {
    type: LIBRARY_PROMO_SET_SALES_TYPE_NAMESPACE,
    payload: { salesTypeNameSpace },
  };
}

export function showPromoAssignOutletWarnModal() {
  return {
    type: LIBRARY_PROMO_SHOW_ASSIGN_OUTLET_WARN_MODAL,
    payload: {},
  };
}

export function hidePromoAssignOutletWarnModal() {
  return {
    type: LIBRARY_PROMO_HIDE_ASSIGN_OUTLET_WARN_MODAL,
    payload: {},
  };
}

export function showPromoAssignSalesTypeModal() {
  return {
    type: LIBRARY_PROMO_SHOW_ASSIGN_SALES_TYPE_MODAL,
    payload: {},
  };
}

export function hidePromoAssignSalesTypeModal() {
  return {
    type: LIBRARY_PROMO_HIDE_ASSIGN_SALES_TYPE_MODAL,
    payload: {},
  };
}

export function onClickAssignSalesTypeButton(
  previousSelectedSalesType,
  selectedSalesTypeForm
) {
  return {
    type: LIBRARY_PROMO_ON_CLICK_ASSIGN_SALES_TYPE,
    payload: { previousSelectedSalesType, selectedSalesTypeForm },
  };
}

export function onClickCancelSalesTypeModal(previousSelectedSalesTypes) {
  return {
    type: LIBRARY_PROMO_ON_CLICK_CANCEL_ASSIGN_SALES_TYPE_MODAL,
    payload: { previousSelectedSalesTypes },
  };
}

export function onChangeSalesTypeNameSpace(salesTypeNameSpace) {
  return {
    type: LIBRARY_PROMO_ON_CHANGE_SALES_TYPE_NAMESPACE,
    payload: { salesTypeNameSpace },
  };
}

export function onClickAssignPromoSalesTypeModal(assignedSalesTypes) {
  return {
    type: LIBRARY_PROMO_ON_CLICK_ASSIGN_PROMO_ASSIGN_SALES_TYPE_MODAL,
    payload: { assignedSalesTypes },
  };
}

export function searchSalesType(salesTypes, searchKeyword) {
  return {
    type: LIBRARY_PROMO_SEARCH_SALES_TYPE,
    payload: { salesTypes, searchKeyword },
  };
}

export function selectAllSalesTypes(allSalesTypesForm) {
  return {
    type: LIBRARY_PROMO_SELECT_ALL_SALES_TYPES,
    payload: { allSalesTypesForm },
  };
}

export function setSelectedSalesTypes(selectedSalesTypes) {
  return {
    type: LIBRARY_PROMO_SET_SELECTED_SALES_TYPES,
    payload: { selectedSalesTypes },
  };
}

export function unselectAllSalesTypes(allSalesTypesForm) {
  return {
    type: LIBRARY_PROMO_UNSELECT_ALL_SALES_TYPES,
    payload: { allSalesTypesForm },
  };
}

export function onChangeAlreadyAssignedOutlet(alreadyAssignedOutlet) {
  return {
    type: LIBRARY_PROMO_ON_CHANGE_ALREADY_ASSIGNED_OUTLET,
    payload: { alreadyAssignedOutlet },
  };
}

export function setAlreadyAssignedOutlet(alreadyAssignedOutlet) {
  return {
    type: LIBRARY_PROMO_SET_ALREADY_ASSIGNED_OUTLET,
    payload: { alreadyAssignedOutlet },
  };
}

export function onConfirmPromoAssignOutletWarnModal(
  selectedOutletIds,
  assignedOutlets,
  salesTypeNameSpace
) {
  return {
    type: LIBRARY_PROMO_ON_CONFIRM_ASSIGN_OUTLET_WARN_MODAL,
    payload: { selectedOutletIds, assignedOutlets, salesTypeNameSpace },
  };
}

export function onShowAssignOutletWarn() {
  return {
    type: LIBRARY_PROMO_SHOW_ASSIGN_OUTLET_WARN,
    payload: {},
  };
}

export function onHideAssignOutletWarn() {
  return {
    type: LIBRARY_PROMO_HIDE_ASSIGN_OUTLET_WARN,
    payload: {},
  };
}

export function onShowAssignSalesTypeWarn() {
  return {
    type: LIBRARY_PROMO_SHOW_ASSIGN_SALES_TYPE_WARN,
    payload: {},
  };
}

export function onHideAssignSalesTypeWarn() {
  return {
    type: LIBRARY_PROMO_HIDE_ASSIGN_SALES_TYPE_WARN,
    payload: {},
  };
}
